import type { SelectOption } from '@components/Select/select.types';
import { Ionicons } from '@expo/vector-icons';
import { Pressable } from 'react-native';
import { SizableText, XStack, useTheme } from 'tamagui';

interface MultiSelectOptionRowProps {
  option: SelectOption;
  selected: boolean;
  onPress: () => void;
  textSize?: string;
  padding?: string;
}

export const MultiSelectOptionRow = ({
  option,
  selected,
  onPress,
}: MultiSelectOptionRowProps): React.ReactElement => {
  const theme = useTheme();

  return (
    <Pressable onPress={onPress}>
      <XStack
        justifyContent="space-between"
        width="100%"
        padding="$3"
        backgroundColor={selected ? '$tertiary50' : '$background'}
      >
        <SizableText size="$3">{option.label}</SizableText>
        {selected && (
          <Ionicons name="checkmark" size={10} color={theme.brand?.val} />
        )}
      </XStack>
    </Pressable>
  );
};
